import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DragScrollItemDirective } from 'ngx-drag-scroll';
import {GalleryList} from "../../shared/entities/gallery-list";

@Component({
  selector: 'gryf-galery',
  templateUrl: './galery.component.html'
})
export class GaleryComponent implements OnInit {
  @Input() imageList: GalleryList[];
  disabled;
  selectedPhoto: null;
  leftNavDisabled = false;
  rightNavDisabled = false;
  @ViewChild('nav', { read: DragScrollItemDirective }) ds: DragScrollItemDirective;
  @ViewChild('nav2', { read: DragScrollItemDirective, static: true }) ds2: DragScrollItemDirective;

  constructor() {
  }

  ngOnInit(): void {
  }

  clickItem(item): void {
  }

  // remove(): void {
  //   this.imagelist.pop();
  // }

  leftBoundStat(reachesLeftBound: boolean): void {
    this.leftNavDisabled = reachesLeftBound;
  }

  rightBoundStat(reachesRightBound: boolean): void {
    this.rightNavDisabled = reachesRightBound;
  }

  selectPhoto(item): void {
    this.selectedPhoto = item;
  }

  removeSelectPhoto(): void {
    this.selectedPhoto = null;
  }
}
